export const canUseSidebarRail = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

export function initialSidebarState() {
  if (window.innerWidth < 768) return "hidden";
  const saved = localStorage.getItem("sidebar_state");
  const closed = saved === "closed" || (saved === null && window.innerWidth <= 1366 && canUseSidebarRail);
  return closed ? (canUseSidebarRail ? "rail" : "hidden") : "open";
}
